import VaspDetailsForm from './VaspDetailsForm'

export default VaspDetailsForm
